import { cva, type VariantProps } from 'class-variance-authority'

export { default as Button } from './Button.vue'

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-semibold transition-colors focus-visible:outline-none ring-offset-white focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        blue: 'bg-blue-600 text-white hover:bg-blue-700',
        gray: 'bg-gray-100 hover:bg-blue-600 hover:text-white',
        orange: 'bg-orange-600 hover:bg-orange-500 text-white',
        white: 'border border-gray-100 bg-white hover:bg-blue-600 hover:text-white',
        green: 'bg-green-400 hover:bg-green-500',
        'outline-blue':
          'border border-blue-600 text-blue-600 bg-white-sm hover:bg-blue-600 hover:text-white',
        'outline-gray':
          'border bg-white-sm hover:border-blue-600 hover:bg-blue-600 hover:text-white',
        destructive: 'bg-red-600 text-white hover:bg-red-700',
        'outline-destructive':
          'border border-red-600 text-red-600 bg-white hover:bg-red-600 hover:text-white',
        ghost: 'hover:bg-gray-100',
        link: 'text-blue-600 hover:text-blue-700 hover:underline'
      },
      size: {
        default: 'h-10 px-5',
        xs: 'h-7 rounded-lg px-2 text-xs',
        sm: 'h-8 rounded-md px-3 text-xs',
        lg: 'h-12 rounded-xl px-8',
        icon: 'size-9 !p-0',
        auto: 'h-auto rounded-sm'
      }
    },
    defaultVariants: {
      variant: 'blue',
      size: 'default'
    }
  }
)

export type ButtonVariants = VariantProps<typeof buttonVariants>
